import clsx from "clsx";
import * as R from "ramda";
import React, { useState } from "react";
import globalMU from "../../../globalMU";

const estiloBotoes =
  require("./../../estilos/botoes.module.scss").default;
const estiloFormulario =
  require("./../../estilos/formulario.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type DadosSugerirProdutoAgregado = {
  CodigoProdutoAnalisado: string;
  CodigoProdutoSugerido: string;
  DescricaoProdutoSugerido: string;
  Unidade: string;
  Preco: string;
  Quantidade_Media_Pedidos: number;
  Percentual_Adesao: number;
  Quantidade_Media_por_Pedido: number;
  Quantidade_Relacionada_Por_Unidade_Produto_Analisado: number;
  TotaldePedidosAnalisados: number;
  UserMessage: string;
  Transforming: boolean;
};

export type ProdutosSugeridos = {
  codigo: string;
};

export type SugerirProdutoAgregadoProps = {
  dadosSugerirProdutoAgregado: DadosSugerirProdutoAgregado[];
  codigo: string;
  descricao: string;
  onOk: (produtosSugeridos: ProdutosSugeridos[]) => void;
  corSelecionado: string;
  textoSelecionado: string;
  foraOrcamento: boolean
};

export const SugerirProdutoAgregado = (props: SugerirProdutoAgregadoProps) => {
  const totalPedidosAnalisados = () => {
    let total = 0;
    props.dadosSugerirProdutoAgregado?.forEach(
      (x) => (total += x.TotaldePedidosAnalisados)
    );
    return total;
  };
  const [
    sugerirProdutosAgregadosSelecionados,
    setSugerirProdutosAgregadosSelecionados,
  ] = useState<DadosSugerirProdutoAgregado[]>([]);

  const toggleSugerirProdutosAgregadosSelecionados = (
    dadosSugerirProdutoAgregado: DadosSugerirProdutoAgregado
  ) => {
    if (
      sugerirProdutosAgregadosSelecionados.includes(dadosSugerirProdutoAgregado)
    ) {
      setSugerirProdutosAgregadosSelecionados(
        R.filter(
          (c) => c != dadosSugerirProdutoAgregado,
          sugerirProdutosAgregadosSelecionados
        )
      );
    } else {
      setSugerirProdutosAgregadosSelecionados(
        sugerirProdutosAgregadosSelecionados.concat(dadosSugerirProdutoAgregado)
      );
    }
  };

  const detalheProdutoSelecionado = (
    <div className={estiloFormulario.gridDuasColunas}>
      <div>Produto</div>
      <div>{props.codigo}</div>
      <div>
        Descrição
      </div>
      <div>{props.descricao}</div>
    </div>
  );

  const quantidadePedidosAnalisados = props.dadosSugerirProdutoAgregado?.length > 0 && (
    <>
      <div className={estiloFormulario.gridDuasColunas}>
        <div>
          Qtde de Pedidos Analisados
        </div>
        <div>
          {globalMU.formatarValorNumerico(totalPedidosAnalisados(), 3)}
        </div>
      </div>
    </>
  )

  const btnOk = !props.foraOrcamento && props.dadosSugerirProdutoAgregado?.length > 0 && (
    <div>
      <button
        className={clsx(`no-global-button ${estiloBotoes.botaoPrimario}`)}
        onClick={() =>
          props.onOk(
            sugerirProdutosAgregadosSelecionados?.map((value) => {
              return { codigo: value.CodigoProdutoSugerido.trim() };
            })
          )
        }
      >
        Ok
      </button>
    </div>
  )

  const table = () => {

    const tableHead = <div className="_table-header-group ">
      <div className="_table-row">
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Código
        </div>

        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Descrição
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
        >
          Unidade
        </div>
        <div
          className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb] _text-right`}
        >
          Preço Unitário
        </div>
        <div className={`_flex _flex-col _font-bold`}>
          <div
            className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          >
            Análise Relacional
          </div>
          <div
            className={`_table-cell _font-bold _align-middle _px-2 _shadow-[1px_1px_rgb(255_255_255/50%)_inset] _bg-[#daddde] _border _border-[#c5cacb]`}
          >
            Qtde Média Relacional
          </div>
        </div>
      </div>
    </div>

    const tableBody = <div className="_table-row-group">
      {props.dadosSugerirProdutoAgregado?.map((value, index) => (
        <div
          key={index}
          className={`_table-row _cursor-pointer hover:_bg-white
                ${sugerirProdutosAgregadosSelecionados.includes(
            value
          ) && `_bg-[#FFFFGG] _text-black`
            }`}
          style={
            sugerirProdutosAgregadosSelecionados.includes(value)
              ? {
                backgroundColor: props.corSelecionado,
                color: props.textoSelecionado,
              }
              : {}
          }
          onClick={() => {
            toggleSugerirProdutosAgregadosSelecionados(value);
          }}
        >
          <div
            className={`_table-cell _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {value.CodigoProdutoSugerido}
          </div>
          <div
            className={`_table-cell  _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {value.DescricaoProdutoSugerido}
          </div>
          <div
            className={`_table-cell  _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {value.Unidade}
          </div>
          <div
            className={`_table-cell _text-right _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {globalMU.formatarValorNumerico(
              Number(value.Preco.replace(",", ".")),
              2,
              true
            )}
          </div>
          <div
            className={`_table-cell _text-right _border _border-[#c5cacb] _px-2 _align-middle`}
          >
            {
              value.Quantidade_Relacionada_Por_Unidade_Produto_Analisado
            }
          </div>
        </div>
      ))}
    </div>

    return props.dadosSugerirProdutoAgregado?.length > 0 && (
      <>
        <div className={estiloTabela.containerRolavel}>
          <div className="_table _w-full _border-collapse">
            {tableHead}
            {tableBody}
          </div>
        </div>
      </>
    )
  }

  return (
    <div>
      {detalheProdutoSelecionado}
      <br />
      {quantidadePedidosAnalisados}
      <br />
      {table()}
      <br />
      {btnOk}
      {<section style={{ marginBottom: "100px" }} />}
    </div>
  );
};
